import styled from 'styled-components';
import { PropsWithPropStyling, propStyling } from '../../shared/propStyling/propStyling';

export type BoxProps = PropsWithPropStyling;

export const Box = styled.div<BoxProps>`
  ${propStyling}
`;
